import {
  FlagEng,
  FlagSpa,
  FlagFra,
  FlagIta,
  FlagDeu,
  FlagPor,
  FlagSwe,
  FlagTur,
  FlagNld,
  FlagPol,
  FlagDan,
  FlagNor,
  FlagInd,
  FlagRus,
  FlagQms
} from 'src/viewLayer/components/DesignSystem';

const flagComponents = {
  FlagEng,
  FlagSpa,
  FlagFra,
  FlagIta,
  FlagDeu,
  FlagPor,
  FlagSwe,
  FlagTur,
  FlagNld,
  FlagPol,
  FlagDan,
  FlagNor,
  FlagInd,
  FlagRus,
  FlagQms
};
interface FlagComponents {
  FlagEng: JSX.Element,
  FlagSpa: JSX.Element,
  FlagFra: JSX.Element,
  FlagIta: JSX.Element,
  FlagDeu: JSX.Element,
  FlagPor: JSX.Element,
  FlagSwe: JSX.Element,
  FlagTur: JSX.Element,
  FlagNld: JSX.Element,
  FlagPol: JSX.Element,
  FlagDan: JSX.Element,
  FlagNor: JSX.Element,
  FlagInd: JSX.Element,
  FlagRus: JSX.Element,
  FlagQms: JSX.Element
}

interface FlagComponentProps {
  flag: string;
}

export default ({ flag }: FlagComponentProps): JSX.Element => {
  const CurrentFlag = flagComponents[flag as keyof FlagComponents];
  return <CurrentFlag />;
};
